/** Official tbi bank accent (https://tbibank.ro/) */
export const TBI_BRAND_COLOR = '#FF6600'

/** Fallback when shop has no default instalments configured. */
export const TBI_DEFAULT_INSTALMENTS = 24

export function resolveTbiInstalments(raw: string | null | undefined): number {
  const n = Number.parseInt(String(raw ?? '').trim(), 10)
  if (Number.isFinite(n) && n >= 2 && n <= 60) return n
  return TBI_DEFAULT_INSTALMENTS
}

/** Rough monthly amount (price ÷ rate). Shown as „de la …” — not a binding TBI quote. */
export function estimateTbiMonthlyPayment(amount: number, instalments: number): number {
  if (!(amount > 0) || instalments < 2) return 0
  return Math.ceil((amount / instalments) * 100) / 100
}
